import React from 'react';
import {
  Box,
  Breadcrumbs,
  Link,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { ButtonBack } from '../../../theme/components';
import useBack from '../../../util/route-dom/hooks/useBack';
import _ from 'lodash';
import { useNavigate } from 'react-router-dom';

export interface BreadcrumbSection {
  key?: string | number;
  content: React.ReactNode;
  href: string;
  onClick?: () => void;
}

export default function Breadcrumb({
  sections,
}: {
  sections: BreadcrumbSection[];
}) {
  const renderSection = (section: BreadcrumbSection, index: number) => {
    if (index === sections.length - 1) {
      return (
        <Typography color="textPrimary" key={section.key ? section.key : index}>
          {section.content}
        </Typography>
      );
    }
    return (
      <Link
        color="inherit"
        href={section.href || '#'}
        key={section.key ? section.key : index}
      >
        {section.content}
      </Link>
    );
  };
  // get the second last section href to navigate back
  const previousUrl = _.nth(sections, -2)?.href || '/';
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box display={'flex'} alignItems={'center'}>
      <ButtonBack href={previousUrl} />
      <Breadcrumbs
        itemsBeforeCollapse={isMobile ? 0 : 1}
        itemsAfterCollapse={2}
        maxItems={isMobile ? 3 : 5}
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
        className="navigation-breadcrumb-new"
      >
        {sections.map(renderSection)}
      </Breadcrumbs>
    </Box>
  );
}
